import Axios from "axios";

// user-profile.js
;(({$, $$, log}) => {
    const profile = $('.user-profile')

    if (!profile) {
        return
    }

    const sectionHiddenClass = 'user-profile__section--hidden'
    const inputVerifiedClass = 'control-wrapper--verified'
    const inputWrapperErrorClass = 'control-wrapper--error'
    const buttonDisabledClass = 'button--disabled'
    const form = profile.querySelector('.user-profile__form')
    const sections = profile.querySelectorAll('.user-profile__section')
    const editButton = profile.querySelector('.user-profile__edit-button')
    const saveButton = profile.querySelector('.user-profile__save-button')
    const nameInput = profile.querySelector('[name="name"]')
    const nameInputWrapper = profile.querySelector('.user-profile__name-input')

    const API = profile.dataset.api

    updateAllowSubmit(false)

    if (
        !form ||
        sections.length != 2 ||
        !editButton ||
        !saveButton ||
        !nameInput ||
        !nameInputWrapper
    ) {
        return
    }
    
    editButton.addEventListener('click', e => {
        e.preventDefault()
        switchToEdit()
    })

    form.addEventListener('submit', e => {
        if (saveButton.classList.contains(buttonDisabledClass)) {
            e.preventDefault()
        }
    })

    let verifyTimer = null
    const verifyDelay = 200

    nameInput.addEventListener('input', e => {
        nameInputWrapper.classList.remove(inputVerifiedClass)
        const { value : name } = e.target
        updateAllowSubmit(false)
        clearTimeout(verifyTimer)
        verifyTimer = setTimeout(async () => {
            try {
                const response = await Axios.get(API, {
                    params: {
                        name
                    }
                })
                const { success, error } = response.data
                if (success) {
                    updateAllowSubmit(true)
                } else {
                    addErrorToInput('name', error)
                }

            } catch (error) {
                updateAllowSubmit(false)
                if (error.response.status === 422) {
                    handleUprocessableData(error.response.data.errors)
                }
            }
        }, verifyDelay)
    })

    function handleUprocessableData(errors) {
        for (const [key, value] of Object.entries(errors)) {
            addErrorToInput(key, value)
        }
    }

    function addErrorToInput(inputName, errorMsg) {
        const input = form.querySelector(`[name="${inputName}"]`)
        if (!input) return

        const wrapper = input.closest('.control-wrapper')
        if (!wrapper) return

        const errorMsgEl = wrapper.querySelector('.control-wrapper__error-msg')
        if (!errorMsg) return

        wrapper.classList.add(inputWrapperErrorClass)
        errorMsgEl.innerText = errorMsg
    }

    function switchToEdit() {
        sections[0].classList.add(sectionHiddenClass)
        sections[1].classList.remove(sectionHiddenClass)
    }

    function updateAllowSubmit(allow) {
        if (allow) {
            nameInputWrapper.classList.add(inputVerifiedClass)
            saveButton.classList.remove(buttonDisabledClass)
        } else {
            saveButton.classList.add(buttonDisabledClass)
        }
    }
})(CNS);